export default {
  // Common
  save: "Speichern",
  cancel: "Abbrechen",
  loading: "Laden...",
  inactive: "Inaktiv",
  active: "Aktiv",
  edit: "Bearbeiten",
  delete: "Löschen",
  name: "Name",
  email: "E-Mail",
  description: "Beschreibung",
  date: "Datum",
  time: "Uhrzeit",
  status: "Status",
  notes: "Notizen",
  close: "Schließen",
  language: "Sprache",

  // Auth
  auth_welcome: "Willkommen zurück",
  auth_create: "Konto erstellen",
  auth_signin_sub: "Bei Ihrem Dashboard anmelden",
  auth_create_sub: "Ihr Buchungssystem einrichten",
  auth_business_name: "Unternehmensname",
  auth_business_placeholder: "Ihr Unternehmensname",
  auth_email_placeholder: "admin@unternehmen.com",
  auth_password: "Passwort",
  auth_password_placeholder: "Passwort eingeben",
  auth_signing_in: "Laden...",
  auth_toggle_login: "Bereits ein Konto? Anmelden",
  auth_toggle_register: "Kein Konto? Jetzt registrieren",
  auth_success_register: "Konto erstellt",
  auth_success_login: "Willkommen zurück!",
  auth_error: "Authentifizierung fehlgeschlagen",
  auth_email_invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  auth_forgot_password: "Passwort vergessen?",
  auth_password_confirm: "Passwort bestätigen",
  auth_password_confirm_placeholder: "Passwort erneut eingeben",
  auth_password_mismatch: "Passwörter stimmen nicht überein",

  forgot_title: "Passwort vergessen",
  forgot_sub: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Reset-Code.",
  forgot_send: "Reset-Code senden",
  forgot_sent_title: "E-Mail überprüfen",
  forgot_sent_sub: "Wir haben einen 6-stelligen Code an Ihre E-Mail-Adresse gesendet. Er läuft in 30 Minuten ab.",
  forgot_enter_code: "Code eingeben",
  forgot_back_login: "Zurück zur Anmeldung",

  reset_title: "Passwort zurücksetzen",
  reset_sub: "Geben Sie den 6-stelligen Code aus Ihrer E-Mail ein und wählen Sie ein neues Passwort.",
  reset_code_label: "Reset-Code",
  reset_new_password: "Neues Passwort",
  reset_password_placeholder: "Min. 4 Zeichen",
  reset_password_hint: "Mindestens 4 Zeichen",
  reset_password_min: "Das Passwort muss mindestens 4 Zeichen lang sein",
  reset_invalid_code: "Ungültiger oder abgelaufener Code",
  reset_submit: "Passwort zurücksetzen",
  reset_done_title: "Passwort aktualisiert!",
  reset_done_sub: "Ihr Passwort wurde geändert. Sie können sich jetzt anmelden.",

  // Sidebar
  nav_dashboard: "Dashboard",
  nav_services: "Dienste",
  nav_staff: "Personal",
  nav_appointments: "Termine",
  nav_calendar: "Kalender",
  nav_settings: "Einstellungen",
  nav_widget: "Widget",
  nav_logout: "Abmelden",

  // Dashboard
  dashboard_title: "Dashboard",
  dashboard_loading: "Dashboard wird geladen...",
  dashboard_today: "Heute",
  dashboard_total: "Buchungen gesamt",
  dashboard_pending: "Ausstehend",
  dashboard_services: "Dienste",
  dashboard_todays_schedule: "Heutiger Zeitplan",
  dashboard_upcoming: "Bevorstehend",
  dashboard_view_all: "Alle anzeigen",
  dashboard_no_today: "Heute keine Termine",
  dashboard_no_upcoming: "Keine bevorstehenden Termine",

  // Services
  services_title: "Dienste",
  services_add: "Dienst hinzufügen",
  services_empty: "Noch keine Dienste",
  services_empty_sub: "Erstellen Sie Ihren ersten Dienst, um Buchungen zu akzeptieren",
  services_new: "Neuer Dienst",
  services_edit: "Dienst bearbeiten",
  services_new_sub: "Einen neuen buchbaren Dienst erstellen",
  services_edit_sub: "Dienstdetails aktualisieren",
  services_name_placeholder: "z.B. Haarschnitt",
  services_desc_placeholder: "Kurze Beschreibung",
  services_duration: "Dauer",
  services_price: "Preis",
  services_buffer: "Pufferzeit",
  services_color: "Farbe",
  services_name_required: "Dienstname ist erforderlich",
  services_created: "Dienst erstellt",
  services_updated: "Dienst aktualisiert",
  services_deleted: "Dienst gelöscht",
  services_load_error: "Fehler beim Laden der Dienste",
  services_save_error: "Fehler beim Speichern",
  services_delete_error: "Fehler beim Löschen",
  services_delete_confirm_title: "Dienst löschen",
  services_delete_confirm_sub: "Möchten Sie {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  services_translations: "Übersetzungen",
  services_trans_name_placeholder: "Dienstname in dieser Sprache",
  services_trans_desc_placeholder: "Beschreibung in dieser Sprache (optional)",

  // Staff
  staff_title: "Personal",
  staff_add: "Personal hinzufügen",
  staff_empty: "Noch keine Mitarbeiter",
  staff_empty_sub: "Fügen Sie Mitarbeiter hinzu, damit Kunden wählen können",
  staff_new: "Personal hinzufügen",
  staff_edit: "Personal bearbeiten",
  staff_new_sub: "Neues Teammitglied hinzufügen",
  staff_edit_sub: "Personaldetails aktualisieren",
  staff_email_optional: "E-Mail (optional)",
  staff_email_placeholder: "john@beispiel.com",
  staff_name_placeholder: "z.B. Max Müller",
  staff_name_required: "Name ist erforderlich",
  staff_created: "Mitarbeiter hinzugefügt",
  staff_updated: "Mitarbeiter aktualisiert",
  staff_deleted: "Mitarbeiter entfernt",
  staff_load_error: "Fehler beim Laden des Personals",
  staff_save_error: "Fehler beim Speichern",
  staff_delete_error: "Fehler beim Löschen",
  staff_delete_confirm_title: "Mitarbeiter löschen",
  staff_delete_confirm_sub: "Möchten Sie {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",

  // Appointments
  appointments_title: "Termine",
  appointments_search: "Nach Name, E-Mail oder Dienst suchen...",
  appointments_filter_all: "Alle",
  appointments_filter_confirmed: "Bestätigt",
  appointments_filter_pending: "Ausstehend",
  appointments_filter_cancelled: "Abgesagt",
  appointments_none: "Keine Termine gefunden",
  appointments_customer: "Kunde",
  appointments_service: "Dienst",
  appointments_staff: "Mitarbeiter",
  appointments_edit: "Bearbeiten",
  appointments_confirm: "Bestätigen",
  appointments_cancel: "Absagen",
  appointments_delete: "Löschen",
  appointments_edit_title: "Termin bearbeiten",
  appointments_edit_sub: "Termindetails aktualisieren",
  appointments_notes_placeholder: "Notizen hinzufügen...",
  appointments_status_updated: "Status aktualisiert: {{status}}",
  appointments_load_error: "Fehler beim Laden",
  appointments_status_error: "Fehler beim Aktualisieren des Status",
  appointments_update_error: "Fehler beim Aktualisieren",
  appointments_delete_error: "Fehler beim Löschen",
  appointments_updated: "Termin aktualisiert",
  appointments_deleted: "Termin gelöscht",

  // Calendar
  calendar_title: "Kalender",
  calendar_today: "Heute",
  calendar_reschedule_ok: "Neu terminiert",
  calendar_reschedule_err: "Fehler beim Neu-Terminieren",
  calendar_load_error: "Fehler beim Laden der Termine",

  // Settings
  settings_title: "Einstellungen",
  settings_save: "Änderungen speichern",
  settings_saving: "Speichern...",
  settings_business_info: "Unternehmensinformationen",
  settings_business_name: "Unternehmensname",
  settings_business_desc: "Beschreibung",
  settings_business_desc_placeholder: "Kurze Beschreibung Ihres Unternehmens",
  settings_booking_url: "Buchungs-URL",
  settings_working_hours: "Öffnungszeiten",
  settings_hours_to: "bis",
  settings_widget_appearance: "Widget-Erscheinungsbild",
  settings_primary_color: "Primärfarbe",
  settings_accent_color: "Akzentfarbe",
  settings_saved: "Einstellungen gespeichert",
  settings_save_error: "Fehler beim Speichern",
  settings_load_error: "Fehler beim Laden der Einstellungen",
  settings_link_copied: "Buchungslink kopiert!",
  settings_approval_title: "Buchungsgenehmigung",
  settings_approval_sub: "Ausstehende Buchungen automatisch bestätigen, wenn sie nicht innerhalb der gewählten Zeit überprüft werden.",
  settings_approval_off: "Aus — nur manuelle Genehmigung",
  settings_approval_30m: "Nach 30 Minuten",
  settings_approval_1h: "Nach 1 Stunde",
  settings_approval_2h: "Nach 2 Stunden",
  settings_approval_6h: "Nach 6 Stunden",
  settings_approval_12h: "Nach 12 Stunden",
  settings_approval_active: "Buchungen werden nach {{hours}}h automatisch bestätigt",
  settings_approval_inactive: "Automatische Genehmigung ist deaktiviert",

  // Widget Preview
  widget_preview_title: "Buchungs-Widget",
  widget_preview_open: "Widget öffnen",
  widget_preview_loading: "Buchungslink wird geladen...",
  widget_preview_embed: "Einbettungscode",
  widget_preview_live: "Live-Vorschau",
  widget_preview_embed_hint: "Kopieren Sie diesen Code in Ihre Website, um das Widget einzubetten.",
  widget_preview_copied: "In die Zwischenablage kopiert",

  // Booking Widget
  booking_book_appointment: "Termin buchen",
  booking_not_found: "Unternehmen nicht gefunden.",
  booking_not_found_sub: "Bitte überprüfen Sie den Buchungslink und versuchen Sie es erneut.",
  booking_step_service: "Dienst",
  booking_step_staff: "Personal",
  booking_step_datetime: "Datum & Uhrzeit",
  booking_step_details: "Details",
  booking_choose_service: "Dienst auswählen",
  booking_no_services: "Keine Dienste verfügbar",
  booking_choose_staff: "Mitarbeiter auswählen",
  booking_any_staff: "Irgendjemand verfügbar",
  booking_any_staff_sub: "Wir weisen den ersten verfügbaren Mitarbeiter zu",
  booking_pick_datetime: "Datum & Uhrzeit wählen",
  booking_available_times: "Verfügbare Zeiten für {{date}}",
  booking_no_slots: "Keine freien Zeiten für dieses Datum",
  booking_continue: "Weiter",
  booking_your_details: "Ihre Angaben",
  booking_name: "Name *",
  booking_email: "E-Mail *",
  booking_phone: "Telefon",
  booking_name_placeholder: "Ihr vollständiger Name",
  booking_email_placeholder: "ihre@email.com",
  booking_phone_placeholder: "Telefonnummer",
  booking_confirm: "Buchung bestätigen",
  booking_confirming: "Buchen...",
  booking_pending_title: "Anfrage erhalten!",
  booking_pending_sub: "Wir senden Ihnen eine E-Mail, sobald Ihr Termin bestätigt wurde.",
  booking_success_title: "Buchung bestätigt!",
  booking_success_sub: "Ihr Termin wurde geplant",
  booking_service_label: "Dienst",
  booking_date_label: "Datum",
  booking_time_label: "Uhrzeit",
  booking_another: "Weiteren Termin buchen",
  booking_failed: "Buchung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  booking_gdpr_text: "Ich stimme zu, dass meine personenbezogenen Daten (Name, E-Mail, Telefonnummer) ausschliesslich zum Zweck der Buchungsverwaltung gemäss den geltenden Datenschutzbestimmungen (DSG/DSGVO) verarbeitet werden. Meine Daten werden nicht an Dritte weitergegeben.",
  booking_select_hint: "Einen oder mehrere Dienste auswählen",
  booking_available: "Verfügbar",
  booking_unavailable: "Nicht verfügbar",
  booking_email_invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
};
